import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "通常" },
  { value: 2, text: "本部一括" },
  { value: 3, text: "不要" },
  { value: 4, text: "都度請求" },
]);
